import React from 'react';
import { COLORS, TYPOGRAPHY, LAYOUT } from '../../constants';

const OnboardingHeader = () => {
  const styles = {
    header: {
      textAlign: 'center',
      marginBottom: LAYOUT.spacing.xxl,
      padding: `0 ${LAYOUT.spacing.lg}`,
    },
    title: {
      ...TYPOGRAPHY.heading1,
      fontSize: '2.5rem',
      fontWeight: '700',
      color: COLORS.text.primary,
      marginBottom: LAYOUT.spacing.md,
      letterSpacing: '-0.02em',
    },
    subtitle: {
      fontSize: '1.2rem',
      color: COLORS.text.secondary,
      lineHeight: '1.6',
      maxWidth: '600px',
      margin: '0 auto',
    }
  };

  return (
    <div style={styles.header}>
      <h1 style={styles.title}>Seller Account Setup</h1>
      <p style={styles.subtitle}>
        Set up your seller account to start earning money on Redbird Markets
      </p>
    </div>
  );
};

export default OnboardingHeader;